import React from 'react';
import NumberFormatField from 'shared/components/numberFormatField/NumberFormatField';

class CreatedExerciseForm extends React.Component {
  prepareExercise = (setFieldValue, exercise, index) => {
    setFieldValue(`ExerciesList[${index}]`, {
      exercise_id: exercise.exercise_id ? exercise.exercise_id : exercise.id,
      exercise_name: exercise.exercise_name ? exercise.exercise_name : exercise.name,
      weight: '',
      tempo: '',
      rest: ''
    });
  }

  componentDidMount(){
    let { values, setFieldValue, index, exercise } = this.props;

    if (!values.ExerciesList[index]) {
      this.prepareExercise(setFieldValue, exercise, index);
    }
  }

  componentWillReceiveProps(newProps) {
    let { values, setFieldValue, index, exercise } = newProps;

    if (exercise && !values.ExerciesList[index]) {
      this.prepareExercise(setFieldValue, exercise, index);
    }
  }

  removeSelectedExercise = () => {
    let { setFieldValue, index, values } = this.props;

    setFieldValue('deletedExercies', [ ...(values.deletedExercies || []), values.ExerciesList[index].id ]);
    setFieldValue(`ExerciesList[${index}]`, null);
    this.props.removeSelectedExercise();
  }

  render() {
    let { index, exercise } = this.props;
    let nameField = (
      <div className="exercies-search">
        <div className="form-group form-group-search">
          <label className="form-label">
            {' '}
            Exercise Name{' '}
          </label>
          <input
            name={`ExerciesList[${index}].exercise_name`}
            type="text"
            placeholder="Search Exercise"
            className="form-control active"
            value={ exercise.exercise_name ? exercise.exercise_name : exercise.name}
            disabled={true}
          />
          <div className='times-icon' onClick={this.removeSelectedExercise}>
            <i className="fas fa-times"></i>
          </div>
        </div>
      </div>
    );

    return (
      <div className="exercies-block" >
        <h4>Exercise {index+1}</h4>
        <div className="form-exercies">

          {nameField}

          <NumberFormatField
            name={`ExerciesList[${index}].weight`}
            label="Weight"
            placeholder="Input Weight"
            allowNegative={false}
            isAllowed={true}
          />

          <NumberFormatField
            name={`ExerciesList[${index}].tempo`}
            label="Tempo"
            placeholder="Input Tempo"
            allowNegative={false}
            isAllowed={true}
            decimalSeparator={false}
          />

          <NumberFormatField
            name={`ExerciesList[${index}].rest`}
            label="Rest (Seconds)"
            placeholder="Input Rest"
            allowNegative={false}
            isAllowed={true}
          />

        </div>
      </div>
    );
  }
}

export default CreatedExerciseForm;
